import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IEmployeeUploadStrings extends LocalizedStringsMethods {
    lsEmployeeTxt: string;
    lsUploadEmpTxt: string;
    lsSelectCSVTxt: string;
    lsRowHdrTxt: string;
    lsRowInfoTxt: string;
    lsRowColsTxt: string;
    lsUploadInfoTxt: string;
    lsUploadInfoTxt2: string;
    lsUploadInfoTxt3: string;
    lsUploadInfoTxt4: string;
    lsUsrInfoTxt: string;
    lsRowNoTxt: string;
    lsUsrNameTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsRoleTxt: string;
    lsHomeTxt: string;
    lsOrgTxt: string;
    lsMobilePhoneTxt: string;
    lsUsrUploadSucessTxt: string;
    lsColTxt: string;
    lsDescTxt: string;
    lsReqTxt: string;
    lsErrTxt: string;
    lsTotalEmpTxt: string;
    lsUploadTxt: string;
    lsClearTxt: string;
    lsHereTxt: string;
    lsUsrNameDescTxt: string;
    lsFNameDescTxt: string;
    lsLNameDescTxt: string;
    lsEmailDescTxt: string;
    lsRoleDescTxt: string;
    lsOrgDescTxt: string; 
    lsMobilePhoneDescTxt: string;

}

let strings: IEmployeeUploadStrings;
export default strings = new LocalizedStrings({
    en: {     
        lsEmployeeTxt: 'Employees',
        lsUploadEmpTxt: 'Upload New Employees',
        lsSelectCSVTxt: 'Select the csv file of employees to upload',
        lsRowHdrTxt: 'First row is header',
        lsRowInfoTxt: 'Each row in the file must contain values for these columns:',
        lsRowColsTxt: 'Username, Firstname, Lastname, Email, Mobile Phone, Role',
        lsUploadInfoTxt: 'CSV stands for Comma Separated Values, and it\'s a file format (.csv) for spreadsheets. \
        A CSV file is a text file where each column is separated using a comma (,).',
        lsUploadInfoTxt2: 'You can download a sample file from {0} \
        Although it can be viewed in Excel to better understand how to construct the CSV \
        file format save it and then use a text editor like Notepad to open the csv file.',
        lsUploadInfoTxt3: 'The sample file when opened in at text editor like Notepad or TextEdit will look like:',
        lsUploadInfoTxt4: 'Then sample file when opened in spreadsheet will look like:',
        lsUsrInfoTxt: 'Employee(s) were added to the system. Below employee(s) were not added to the system:',
        lsRowNoTxt: 'Row Number',
        lsUsrNameTxt: 'Username',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Role',
        lsHomeTxt: 'Home',
        lsOrgTxt: 'Organization',
        lsMobilePhoneTxt: 'Mobile Phone',
        lsUsrUploadSucessTxt: 'Employee(s) uploaded successfully!',
        lsColTxt: 'Column',
        lsDescTxt: 'Description',
        lsReqTxt: 'Required',
        lsErrTxt: 'Error Msg(s)',
        lsTotalEmpTxt: 'Total {0} employees',
        lsUploadTxt: 'Upload',
        lsClearTxt: 'Clear',
        lsHereTxt: 'here',
        lsUsrNameDescTxt: 'Username',
        lsFNameDescTxt: 'First Name',
        lsLNameDescTxt: 'Last Name',
        lsEmailDescTxt: 'Email',
        lsRoleDescTxt: 'Role',
        lsOrgDescTxt: 'Organization',
        lsMobilePhoneDescTxt: 'Mobile Phone',
    },
    es: {
        lsEmployeeTxt: 'Usuarios',
        lsUploadEmpTxt: 'Subir nuevos usuarios',
        lsSelectCSVTxt: 'Seleccione el archivo csv de usuarios para cargar',
        lsRowHdrTxt: 'La primera fila es encabezado',
        lsRowInfoTxt: 'Cada fila en el archivo debe contener valores para estas columnas:',
        lsRowColsTxt: 'Username, Firstname, Lastname, Email, Mobile Phone, Role',
        lsUploadInfoTxt: 'CSV significa valores separados por comas, \
        y es un formato de archivo (.csv) para hojas de cálculo. \
        Un archivo CSV es un archivo de texto donde cada columna se separa mediante una coma (,).',
        lsUploadInfoTxt2: 'Puede descargar un archivo de muestra de {0} aquí. \
        Aunque se puede ver en Excel para comprender mejor cómo construir el CSV \
        formato de archivo guárdelo y luego use un editor de texto como el \
        Bloc de notas para abrir el archivo csv.',
        lsUploadInfoTxt3: 'El archivo de muestra cuando se abre en un editor\
        de texto como Notepad o TextEdit se verá así:',
        lsUploadInfoTxt4: 'Luego, el archivo de muestra cuando se abre en la hoja de cálculo se verá así:',
        lsUsrInfoTxt: 'Usuario (s) se agregaron al sistema. Debajo de los usuarios no se agregaron al sistema:',
        lsRowNoTxt: 'Numero de fila',
        lsUsrNameTxt: 'Nombre de usuario',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Role',
        lsHomeTxt: 'Casas',
        lsOrgTxt: 'Organización',
        lsMobilePhoneTxt: 'Teléfono móvil',
        lsUsrUploadSucessTxt: 'Usuarios cargados con éxito!',
        lsColTxt: 'Columna',
        lsDescTxt: 'Descripción',
        lsReqTxt: 'Necesario',
        lsErrTxt: 'Error Msg(s)',
        lsTotalEmpTxt: 'Total {0} usuarios',
        lsUploadTxt: 'Subir',
        lsClearTxt: 'Clear',
        lsHereTxt: 'here',
        lsUsrNameDescTxt: 'Nombre de usuario',
        lsFNameDescTxt: 'Nombre de pila',
        lsLNameDescTxt: 'Apellido',
        lsEmailDescTxt: 'Email',
        lsRoleDescTxt: 'Role',
        lsOrgDescTxt: 'Organización',
        lsMobilePhoneDescTxt: 'Teléfono móvil',
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/employee/strings.employee.upload.tsx